import React from 'react';

export const PushpayLogo = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 1200 335.8" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M170.6,7.8C82.1,7.8,10.4,79.5,10.4,167.9s71.7,160.2,160.2,160.2s160.2-71.7,160.2-160.2S259.1,7.8,170.6,7.8
		z"
			fill="#414042"
			stroke="1"
		/>
		<g>
			<path
				d="M207.5,93h-38.9l-29,149.7h25.7l8.7-46.6h29c32.3,0,59.3-19.7,59.3-55.2C262.3,115.1,245.5,93,207.5,93z
			 M201,173.3h-22.5l11.2-57.2h19c15.3,0,28,8.1,28,25.7C236.6,162.5,220.4,173.3,201,173.3z"
				fill="#ffffff"
				stroke="1"
			/>
			<polygon fill="#ffffff" points="141.3,93 112.3,242.7 124.5,242.7 153.3,93" stroke="1" />
			<polygon fill="#ffffff" points="113.9,93 85,242.7 97.1,242.7 126,93" stroke="1" />
		</g>
		<g>
			<path
				d="M597.8,193.1c0,18-9.6,29.3-24.4,29.3c-14.3,0-22.7-9.8-22.7-26.1v-58.4h-24.8V201c0,27.2,15.2,44.3,40,44.3
			c14.6,0,25.5-6.6,31.9-16.5v13.9h24.8V137.9h-24.8V193.1z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M660.6,167c0-6.4,6.6-10.1,16.7-10.1c12.8,0,25,5.1,34.9,13.5v-25.9c-9.6-5.4-21.8-9.2-34-9.2
			c-24.6,0-41.7,13.3-41.7,33.8c0,38.7,56.3,23.3,56.3,42.8c0,8.3-7.5,11.6-17.5,11.6c-13.5,0-27.4-6.2-37.9-15v26.7
			c10.3,6.4,23.3,10.1,38.9,10.1c22,0,41.1-12.2,41.1-34.9C717.3,171.7,660.6,185.2,660.6,167z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M785.8,135.4c-14.8,0-25.7,6.6-32.1,16.5V93h-24.8v149.8h24.8v-55.2c0-18,9.8-29.3,24.6-29.3
			c15,0,23.3,9.8,23.3,26.1v58.4h24.8v-63.1C826.5,152.5,811.3,135.4,785.8,135.4z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M901.8,135.4c-14.6,0-27.8,6.8-35.5,17.5v-15h-24.6v149.4h24.6v-58.9c7.7,10.7,21,16.9,35.5,16.9
			c28.9,0,51.1-24.2,51.1-55C953,159.1,930.7,135.4,901.8,135.4z M896.7,222.9c-17.8,0-31.5-14.3-31.5-32.5s13.7-32.5,31.5-32.5
			c17.8,0,31.4,14.3,31.4,32.5S914.4,222.9,896.7,222.9z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M1048.8,152.3c-7.7-10.7-21-16.9-35.5-16.9c-28.9,0-51.1,24.2-51.1,55c0,31.2,22.3,55,51.1,55
			c14.6,0,27.8-6.8,35.5-17.5v15h24.6V137.9h-24.6V152.3z M1018.4,222.9c-17.8,0-31.5-14.3-31.5-32.5s13.7-32.5,31.5-32.5
			c17.8,0,31.4,14.3,31.4,32.5S1036.1,222.9,1018.4,222.9z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M1164.1,137.9l-29.5,75.5l-28.7-75.5h-26.3l41.9,103.4l-4.5,10.9c-4.9,11.8-10.5,16-19.2,16
			c-4.1,0-7.9-0.8-10.9-2.1v21.2c3.4,1.5,8.1,3,14.6,3c17.8,0,29.3-10.1,39.6-34.9l48.6-117.5H1164.1z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M458.7,93h-43.4v149.8H441v-46.6h14.8c33,0,59.9-18,59.9-51.8C515.7,113.8,493.6,93,458.7,93z M457.7,173.3
			H441v-57.2h16.7c21.4,0,31.7,11.1,31.7,28.9C489.4,161.1,478.5,173.3,457.7,173.3z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M1182.9,230.1c0-2.6-2-4.2-5-4.2h-5.8V239h2.5v-4.5h2.7l3.2,4.5h3l-3.5-4.9
			C1181.6,233.6,1182.9,232.2,1182.9,230.1z M1177.7,232.3h-3.2v-4.1h3.2c1.6,0,2.6,0.7,2.6,2.1
			C1180.3,231.5,1179.4,232.3,1177.7,232.3z"
				fill="#414042"
				stroke="1"
			/>
			<path
				d="M1177.1,220.3c-7,0-12.5,5.7-12.5,12.5c0,6.8,5.5,12.5,12.5,12.5c7,0,12.5-5.7,12.5-12.5
			S1184.1,220.3,1177.1,220.3z M1177,244.1c-6.4,0-11.2-5-11.2-11.2c0-6.2,4.8-11.3,11.2-11.3c6.4,0,11.2,5,11.2,11.2
			C1188.2,239,1183.4,244.1,1177,244.1z"
				fill="#414042"
				stroke="1"
			/>
		</g>
	</svg>
);
